/// <reference path="" />

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    /**************************************/
    // Terms and Conditions Paragraph View Model
    // Terms and Conditions Paragarph Processing Information
    /**************************************/
    function TermsConditionsParagraphViewModel(termsType){

        // Self-Identification
        var self = this;

        /***  PROPERTIES ***/
        this.ParagraphVersionID = ko.validatedObservable();
        this.HistoryID = ko.validatedObservable();
        this.Title = ko.observable();
        this.HTMLContent = ko.observable();
		this.Accepted = ko.validatedObservable();
		this.Latest = ko.observable();
        this.Required = ko.validatedObservable();
        this.Revocable = ko.validatedObservable();
        this.SortOrder = ko.validatedObservable();
        this.Type = ko.observable();
        this.LastChange = ko.observable();
        this.AcceptanceChanged = ko.observable(false);
        this.IsLatestVersion = ko.observable(true);
        this.LatestVersionHTML = null;
        this.OriginalHTML = "";
        this.Obsolete = ko.observable();

        /***  PROPERTIES ***/

        /*** SECTION PROPERTIES ***/
        this.DataLoaded = ko.observable(false);
        this.DataLoading = ko.observable(false);
        this.Touched = ko.observable(false);
        this.DataLoadErrorCount = ko.observable(0);
        /*** SECTION PROPERTIES ***/

        /*** COMPUTED PROPERTIES ***/
        this.IsUpdatedVersionAvaliable = ko.computed(function () {
                if (self.Type() == 'TermsConditionsParagraphType.Regular') {
                    return !self.Accepted() && !self.AcceptanceChanged() && !self.IsLatestVersion();
                }

                return false;
            },
            this);

        this.CanChange = ko.computed(function () {
            if (self.Obsolete()) {
                return false;
            }
                
            if (!self.IsUpdatedVersionAvaliable()) {
                if (!self.Accepted() || self.Revocable() || self.WasClicked()) {
                    return true;
                }
            }

            return false;
            },
            this);

        this.WasClicked = ko.computed(function () {

                var data = {
                    self: self,
                    termsType: termsType
                }

                sm.portal.vm.custom.callCustomization('Beforetermsflag',data);

                if (!self.AcceptanceChanged() && self.Accepted() !== undefined && this.LoadedAccepted !== undefined) {
                    if (self.Accepted() != this.LoadedAccepted) {
                        self.AcceptanceChanged(true);
                        return true;
                    }
                }

                if (self.AcceptanceChanged()) {
                    return true;
                }

                return false;
            },
            this);

        /***  COMPUTED PROPERTIES ***/

        /***  LIST DATA PROPERTIES ***/
        /***  LIST DATA PROPERTIES ***/

        /*** METHODS ***/
        /*** METHODS ***/

        /*** SECTION METHODS ***/
        this.LoadModel = function (container){

            this.ParagraphVersionID(container.ParagraphVersionID);
            this.HistoryID(container.HistoryID);
            this.Title(container.Title);
            this.HTMLContent(container.HTMLContent);
			this.Accepted(container.Accepted);
			this.Latest(container.Latest);
            this.Required(container.Required);
            this.Revocable(container.Revocable);
            this.SortOrder(container.SortOrder);
            this.Type(container.Type);
            this.LastChange(container.LastChangeDate);
            this.IsLatestVersion(container.IsLatestVersion);
            this.LoadedAccepted = container.Accepted;
            this.LatestVersionHTML = null;
            this.OriginalHTML = container.HTMLContent;
            this.Obsolete(container.Obsolete);

            var data = {
                self: self,
                termsType: termsType,
                container: container
            }
            
            sm.portal.vm.custom.callCustomization('UpdatedLoadModelTermsConditions',data);
        };

        this.Initialize = function (){
        };
        this.BlockContainer = function (){
            jQuery("#" + self.DataContainer()).block({ message : sm.portal.utility.getResourceValue('Loading') });
        };
        this.UnBlockContainer = function (){
            jQuery("#" + self.DataContainer()).unblock();
            viewModel.SetFocus();
        };
        this.ProcessOnServer = function (){

        };
        this.ExtractATO = function (){
            // [EXTEND] New fields added to view model need to be updated here
            return null;
        };
        this.CheckForLatestVersion = function () {
            jQuery.blockUI();

            var url = _baseApiUri + sm.portal.utility.formatString('api/studenttermsconditionshistory/CheckForLatestVersion?id={0}', self.HistoryID());

            jQuery.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1'
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {
                    var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                    if (data.Status == 'success') {

                        if (container.Payload.LatestParagraph != null) {

                            self.LatestVersionHTML = container.Payload.LatestParagraph;
                            var checked = self.Accepted() ? "checked" : "";
                            sm.portal.ui.lightBox(
                                sm.portal.utility.getResourceValue('ThisTermChangedMsg'),
                                '<div class="modalBoxWrapper"><input type="checkbox" id="updatedAccept" ' + checked + ' /><div class="smModalInner paragraphContentWraper">' + container.Payload.LatestParagraph + '</div></div>',
                                null,
                                function () {
                                    jQuery('.confirmBtn').on('click',null, self, function (p) {

                                        var paragraph = p.data;

                                        if (paragraph != null) {
                                                
                                            var value = window.jQuery.find("#updatedAccept")[0].checked;
                                            paragraph.AcceptLatestVersion(value);
                                        }
                                            
                                        sm.portal.ui.removeLightbox();

                                        });
                                    },
                                null,
                                '<button class="cancelBtn" data-close-lightbox>' + sm.portal.utility.getResourceValue('Cancel') + '</button><button class="confirmBtn">' + sm.portal.utility.getResourceValue('Ok') + '</button>',
                               'TermsAndConditons');
                        }
                    }
                    else if (data.Status == 'validationerror') {

                        viewModel.HandleError(container.ValidationTitle, container.ValidationMessages);

                    } else if (data.Status == 'error') {

                        viewModel.HandleError(container.ValidationTitle, container.ValidationMessages);
                    }

                    jQuery.unblockUI();
                },
                error: function (jqXHR, exception) {
                    if (jqXHR.status == 401) {
                        var title = sm.portal.utility.getResourceValue('UnAuthorized');
                        var body = sm.portal.utility.getResourceValue('NotAuthorizedToViewPage');
                        viewModel.HandleError(title, [body]);
                    } else {
                        viewModel.HandleError(exception);
                    }
                    jQuery.unblockUI();
                }
            });

        };

        this.AcceptLatestVersion = function (checked){
            self.Accepted(checked);
            if (checked) {
                self.HTMLContent(self.LatestVersionHTML);
            }
            else {
                self.HTMLContent(self.OriginalHTML);
            }
            
        };
        /*** SECTION METHODS ***/
        /*** VALIDATION METHODS ***/

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid 
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {

            var isCompleted = true;
            isCompleted = this.IsVMValid();

            if (this.Type() == 'TermsConditionsParagraphType.Regular' && isCompleted && this.Required() && !this.Accepted()) {
                isCompleted = false;
            }

            return isCompleted;

        }, this);
        /*** VALIDATION METHODS ***/


        return self;
    };

    jQuery.extend(true, sm.portal.vm, {
        TermsConditionsParagraphViewModel: TermsConditionsParagraphViewModel,
    });

})(jQuery);